function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-632.655,-1209.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Final-Comment-Icon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966014,0,0,0.966014,92.1905,27.8636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.527,1283.5C604.644,1286.59 598.858,1288.38 592.657,1288.38C575.203,1288.38 561.032,1274.21 561.032,1256.75C561.032,1239.3 575.203,1225.13 592.657,1225.13C610.111,1225.13 624.282,1239.3 624.282,1256.75C624.282,1262.84 622.559,1268.53 619.574,1273.35L624.329,1288.5L609.527,1283.5Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.3px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dots",
    transform: "matrix(1,0,0,1,72.0485,-14.5736)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.13041,-0.199847)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 577.484,
    cy: 1256.64,
    r: 3.254,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.484,1253.39C579.28,1253.39 580.738,1254.85 580.738,1256.64C580.738,1258.44 579.28,1259.9 577.484,1259.9C575.688,1259.9 574.23,1258.44 574.23,1256.64C574.23,1254.85 575.688,1253.39 577.484,1253.39ZM577.484,1255.39C576.792,1255.39 576.23,1255.95 576.23,1256.64C576.23,1257.33 576.792,1257.9 577.484,1257.9C578.176,1257.9 578.738,1257.33 578.738,1256.64C578.738,1255.95 578.176,1255.39 577.484,1255.39Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,30.4762,-0.199847)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 577.484,
    cy: 1256.64,
    r: 3.254,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.484,1253.39C579.28,1253.39 580.738,1254.85 580.738,1256.64C580.738,1258.44 579.28,1259.9 577.484,1259.9C575.688,1259.9 574.23,1258.44 574.23,1256.64C574.23,1254.85 575.688,1253.39 577.484,1253.39ZM577.484,1255.39C576.792,1255.39 576.23,1255.95 576.23,1256.64C576.23,1257.33 576.792,1257.9 577.484,1257.9C578.176,1257.9 578.738,1257.33 578.738,1256.64C578.738,1255.95 578.176,1255.39 577.484,1255.39Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,15.1928,-0.199847)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 577.484,
    cy: 1256.64,
    r: 3.254,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.484,1253.39C579.28,1253.39 580.738,1254.85 580.738,1256.64C580.738,1258.44 579.28,1259.9 577.484,1259.9C575.688,1259.9 574.23,1258.44 574.23,1256.64C574.23,1254.85 575.688,1253.39 577.484,1253.39ZM577.484,1255.39C576.792,1255.39 576.23,1255.95 576.23,1256.64C576.23,1257.33 576.792,1257.9 577.484,1257.9C578.176,1257.9 578.738,1257.33 578.738,1256.64C578.738,1255.95 578.176,1255.39 577.484,1255.39Z",
    style: {
      fill: "white"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.74e55b2d1bfffc51f7766ef2a780a2c2.svg";
export { ForwardRef as ReactComponent };